/* eslint-disable react/jsx-newline */

import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import type { Category } from "../../../../../../../server/models/category";
import { AccordionForm } from "../../../../parts/accodion-form";
import { BrandSelect } from "./brand-select";
import { StrategyGroup, StrategyGroupCategory } from "../../../../../../../server/models/activity";
import { strategyGroupCategoryLabels } from "../../../../../../../label/activity";

type Props = {
	categoryMap: Record<string, Category>;
	onChangeStrategyGroupCategory: (surveyChoice: number, name: keyof StrategyGroupCategory, value: any) => void;
	strategyGroup: StrategyGroup;
	surveyChoiceMap: Map<number, string>;
};

/**
 * 過去1年購入＆使用ブランド
 */
export const UsedBrandForms = React.memo((props: Props) => {
	const { categoryMap, onChangeStrategyGroupCategory, strategyGroup, surveyChoiceMap } = props;

	return (
		<Row>
			<FormGroup as={Col}>
				<AccordionForm
					defaultShow={strategyGroup.category?.some((cate) => !!cate.usedBrand && cate.usedBrand.length !== 0)}
					eventKey="usedBrand"
					title={strategyGroupCategoryLabels.usedBrand ?? ""}
				>
					<Row style={{ paddingLeft: "15px" }}>
						{strategyGroup.category?.map((category) => (
							<Col key={`usedBrand-category-${category.surveyChoice}`} md={5} style={{ paddingBottom: "1em" }}>
								{" "}
								{surveyChoiceMap.get(category.surveyChoice)}
								<BrandSelect
									category={categoryMap[category.category._id?.toString() ?? ""]}
									filteredValue={category.unusedBrand}
									onChange={(values) => onChangeStrategyGroupCategory(category.surveyChoice, "usedBrand", values)}
									values={category.usedBrand}
								/>
							</Col>
						))}
					</Row>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
